import React, { Dispatch } from 'react'
import { connect } from 'react-redux'
import { AppState } from '../../../../store';
import { getWordId, thunkAddWord, thunkRemoveWord } from '../../../../modules/words';
import './translationItem.scss';

export interface TranslationItemOwnProps {
    original: string,
    targetTranslation: string,
    backTranslations: string[]
}

interface TranslationItemStateProps {
    isWordAdded: boolean,
    wordId: string | undefined
}

interface TranslationItemDispatchProps {
    addWord: () => void,
    removeWord: (wordId: string) => void
}

export interface TranslationItemProps extends TranslationItemOwnProps, TranslationItemDispatchProps, TranslationItemStateProps {
}


class TranslationItem extends React.Component<TranslationItemProps> {

    constructor(props: TranslationItemProps) {
        super(props);

        this.onWordAdded = this.onWordAdded.bind(this);
        this.onWordRemoved = this.onWordRemoved.bind(this);
    }

    onWordAdded(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        this.props.addWord();
    }

    onWordRemoved(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        this.props.removeWord(this.props.wordId as string);
    }

    render() {
        const renderButton = () => {
            if (!this.props.isWordAdded) {
                return <button className="TranslationItem__ToggleAddedButton" onClick={e => this.onWordAdded(e)}>Add</button>;
            } else {
                return <button className="TranslationItem__ToggleAddedButton__Toggled" onClick={e => this.onWordRemoved(e)}>Remove</button>;
            }
        };

        return (
            <div className="TranslationItem">
                <span className="TranslationItem__Translation">{this.props.targetTranslation}</span>
                <p className="TranslationItem__Synonyms">{this.props.backTranslations.join(", ")}</p>
                {renderButton()}
            </div>
        );
    }
}

const mapStateToProps = (state: AppState, ownProps: TranslationItemOwnProps) : TranslationItemStateProps => {
    let wordId = getWordId(state.words, ownProps.original, ownProps.targetTranslation);

    return {
        isWordAdded: !!wordId,
        wordId: wordId
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>, ownProps: TranslationItemOwnProps) : TranslationItemDispatchProps => {
    return {
        addWord: () => dispatch(thunkAddWord(ownProps.original, ownProps.targetTranslation)),
        removeWord: (wordId) => dispatch(thunkRemoveWord(wordId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TranslationItem)